import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import classNames from 'classnames'
import wind from './icons/wind-arrow.svg'
import drop from './icons/drop.svg'
import rain from './icons/rain.svg'

const degreeSymbol = '\u00B0'

const WeatherDay = ({ dailyData, isExpanded, label, onDayClick }) => {

  const dateISO = dailyData.get('date')

  let maxTemperature = Math.floor(dailyData.get('maxTemperature'))
  let minTemperature = Math.floor(dailyData.get('minTemperature'))
  maxTemperature = (maxTemperature > 0 ? '+' : '' ) + maxTemperature + degreeSymbol
  minTemperature = (minTemperature > 0 ? '+' : '' ) + minTemperature + degreeSymbol

  const precipitationOneDecimal = Math.round(dailyData.precipitation * 10) / 10

  return (
    <button
      onClick={ () => onDayClick(dateISO) }
      className='weekly-weather-day'
      type='button'
      title={ isExpanded ? 'Sulje' : 'Katso tuntikohtaiset ennusteet' }
      aria-expanded={ isExpanded }
      aria-label={ `${label}, ${isExpanded ? 'Sulje' : 'Näytä'} tuntikohtaiset ennusteet` }
    >
      <time className='weather-time' dateTime={ dateISO }>
        { label }
        { isExpanded ? <i className='fa fa-caret-up' /> : <i className='fa fa-caret-down' /> }
      </time>
      <span className='weather-symbol'>
        <span className={ classNames(dailyData.get('symbol')) } />
      </span>

      <span className='weather-temperature-container'>
        <span className='weather-temperature'>{ maxTemperature }</span>
        <span className='weather-min-temperature'>{ 'alin ' + minTemperature }</span>
      </span>

      <span className='weather-wind'>
        <span className={ classNames('weather-wind__image__wrapper weather-wind-direction', dailyData.get('windDirection')) } aria-hidden='true' >
          <img
            className='weather-wind__image'
            alt=''
            src={ wind }
            width={ 15 }
            height={ 15 }
          />
        </span>
        <span className='weather-value'>{ dailyData.get('windSpeed') + ' m/s' }</span>
      </span>

      <span className='weather-min-max-rain-change'>
        <span className='weather-min-max-rain-change__image__wrapper'>
          <img
            className='weather-min-max-rain-change__image'
            alt=''
            src={ drop }
            width={ 15 }
            height={ 15 }
          />
        </span>
        <span className='weather-min-max-rain-change__value weather-value'>{ precipitationOneDecimal + ' mm' }</span>
      </span>

      <span className='weather-precipitation-probability'>
        <span className='weather-precipitation-probability__image__wrapper'>
          <img
            className='weather-precipitation-probability__image'
            alt=''
            src={ rain }
            width={ 15 }
            height={ 15 }
          />
        </span>
        <span className='weather-value'>{ dailyData.get('precipitationProbability') + ' %' }</span>
      </span>
    </button>
  )

}

WeatherDay.propTypes = exact({
  dailyData: ImmutablePropTypes.map.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onDayClick: PropTypes.func.isRequired,
})

export default WeatherDay
